type Args = {
  activeSlotCount: number
  postingGoal?: number | null
}

export function getTakeawayScheduleTarget({
  activeSlotCount,
  postingGoal,
}: Args): number {
  const goal = postingGoal && postingGoal > 0 ? postingGoal : 3
  return Math.max(goal, 3, activeSlotCount + 1)
}
